module.exports = __webpack_public_path__ + "static/media/BookLogo.db28a2b6.svg";